import Card, { CardProps } from 'antd/lib/card';
import React from 'react';

import style from './SDSCard.scss';

export default function SDSCard(props: CardProps) {
  return <Card {...props} className={style.styledCard} />;
}
